var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H1.5V21.5C1.5 21.8978 1.65804 22.2794 1.93934 22.5607C2.22064 22.842 2.60218 23 3 23H22.5V21.5H3V2Z",
    fill: "#C93030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.25H17.25V8.75H19.9425L14.25 14.4425L11.0325 11.2175C10.9628 11.1472 10.8798 11.0914 10.7884 11.0533C10.697 11.0153 10.599 10.9957 10.5 10.9957C10.401 10.9957 10.303 11.0153 10.2116 11.0533C10.1202 11.0914 10.0372 11.1472 9.9675 11.2175L4.5 16.6925L5.5575 17.75L10.5 12.8075L13.7175 16.0325C13.7872 16.1028 13.8702 16.1586 13.9616 16.1967C14.053 16.2347 14.151 16.2543 14.25 16.2543C14.349 16.2543 14.447 16.2347 14.5384 16.1967C14.6298 16.1586 14.7128 16.1028 14.7825 16.0325L21 9.8075V12.5H22.5V7.25Z",
    fill: "#C93030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.de4bcad20f863a07214ff641c3034c6a.svg";
export { ForwardRef as ReactComponent };